import React, { Component } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import { translate } from "react-i18next";
import de from 'date-fns/locale/de';
import i18n from "i18next";
import { Form, Card } from 'react-bootstrap';
import {EVENT_STATISTICS} from '../../backend/Data';

registerLocale('de', de)

function emptyCriteria() {
    return {
        startDate: new Date().getTime(),
        endDate: new Date().getTime()
    };
}


class AdminStatisticSearch extends Component {

    constructor(...args) {
        super(...args);

        this.onEventInputChange = this.onEventInputChange.bind(this);
        this.onEventStartDateChange = this.onEventStartDateChange.bind(this);
        this.onEventEndDateChange = this.onEventEndDateChange.bind(this);

        this.searchEvent = this.searchEvent.bind(this);

        this.state = {
            criteria: emptyCriteria()
        };
    }



    onEventStartDateChange(obj) {
        const { criteria } = this.state;

        const newEvent = {
            ...criteria,
            startDate: obj ? obj.getTime() : null
        };

        this.setState({
            criteria: newEvent
        });
    }

    onEventEndDateChange(obj) {
        const { criteria } = this.state;

        const newEvent = {
            ...criteria,
            endDate: obj ? obj.getTime() : null
        };

        this.setState({
            criteria: newEvent
        });
    }

    onEventInputChange(obj) {
        const { name: fieldName, value: fieldValue } = obj.target;
        const { criteria } = this.state;

        let selectedCat = this.state.category;
      

        const newEvent = {
            ...criteria,
            [fieldName]: fieldValue
        };

        this.setState({
           
            criteria: newEvent
        });
    }




    searchEvent() {
        this.props.searchEvents(this.state.criteria, 1);
    }



    render() {
        let lang = i18n.language;
        const { t } = this.props;
        const { criteria: { startDate, endDate , unitID} } = this.state;
        return (
            <div>
                <Card text={"black"} className="mb-2 bold">
                    <Card.Header ><i className="fa fa-search mr-1"></i>{t("statistics")}</Card.Header>
                    <Card.Body className="pb-0">
                        <Form>

                            <Row>
                                <Col className="float-left " lg={3} >
                                    <Form.Group controlId="what" >
                                        <Form.Label>{t("unitID") + "?"}</Form.Label>
                                        <Form.Control as="select" name="unitID" value={unitID} onChange={this.onEventInputChange} defaultValue="0">
                                            <option value="0">{t("unitIDChoose")}</option>
                                            {EVENT_STATISTICS.map(c =>
                                                <option value={c.value} key={c.value} label={c.label}></option>
                                            )}
                                        </Form.Control>
                                    </Form.Group>
                                </Col>
                                <Col className="float-left " lg={3} >
                                    <Form.Group controlId="when">
                                        <Form.Label>{t("from") + "?"}</Form.Label>
                                        <DatePicker
                                            selected={startDate}
                                            onChange={this.onEventStartDateChange}
                                            dateFormat="dd MMM yyyy"
                                            locale="de"
                                            className="form-control"
                                        />
                                    </Form.Group>
                                </Col>
                                <Col className="float-left " lg={3} >
                                    <Form.Group controlId="when">
                                        <Form.Label>{t("to") + "?"}</Form.Label>
                                        <DatePicker
                                            selected={endDate}
                                            onChange={this.onEventEndDateChange}
                                            dateFormat="dd MMM yyyy"
                                            locale="de"
                                            className="form-control"
                                        />
                                    </Form.Group>
                                </Col>


                                <Col lg={3}>
                                    <Form.Group controlId="when">
                                        <Form.Label>{t("search")}</Form.Label>
                                        <Button variant={"primary"} onClick={this.searchEvent} block size="sm">
                                            <i className="fa fa-search mr-1"></i>{t("search")}
                                        </Button>
                                    </Form.Group>

                                </Col>
                            </Row>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        );
    }
}

export default translate("translations")(AdminStatisticSearch);